import { render, staticRenderFns } from "./PagoObservaciones.vue?vue&type=template&id=c398276e&scoped=true&"
import script from "./PagoObservaciones.vue?vue&type=script&lang=js&"
export * from "./PagoObservaciones.vue?vue&type=script&lang=js&"
import style0 from "./PagoObservaciones.vue?vue&type=style&index=0&id=c398276e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c398276e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VLayout,
})
